<template>
  <div class="faq-container">
    <h1 class="page-title">
      <img src="/images/geogrid.svg" class="geogrid-logo" /> GeoGrid - Frequently Asked Questions
    </h1>
    <div class="faq-content">
      <div class="faq-item" id="what-is-geogrid">
        <h3>
          <a href="#what-is-geogrid" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          What is GeoGrid?
        </h3>
        <p>
          GeoGrid is a daily <strong>geography trivia game</strong> made to put your geography
          knowledge to the test! Combining the concept of grid-games with geography, we believe it's
          one of the best daily geography games on the planet.
        </p>
      </div>

      <div class="faq-item" id="how-does-geogrid-work">
        <h3>
          <a href="#how-does-geogrid-work" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          How does GeoGrid work?
        </h3>
        <p>
          You must guess a country for each square in the board that matches the criteria specified
          by the square's row and column headers.
        </p>
        <p>
          When you get a correct answer, your score is calculated based on the percentage of people
          who also chose this answer. The rarer your answer, the lower your score. And lower score =
          better.
        </p>
      </div>

      <div class="faq-item" id="how-many-answers">
        <h3>
          <a href="#how-many-answers" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          How many answers are there for a given square?
        </h3>
        <p>Each square on a given board has a minimum of 5 and up to 30 unique answers.</p>
      </div>

      <div class="faq-item" id="when-new-game">
        <h3>
          <a href="#when-new-game" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          When is a new game available?
        </h3>
        <p>
          GeoGrid is a daily game. A new game is released every day at 0:00 am (midnight), local
          time of your device!
        </p>
      </div>

      <div class="faq-item" id="is-geogrid-free">
        <h3>
          <a href="#is-geogrid-free" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          Is GeoGrid free to play?
        </h3>
        <p>
          Yes, GeoGrid is completely free to play! You will see ads*, which is how we support
          continued development of our educational, geography-based games at
          <a href="https://teuteuf.fr/" target="_blank" rel="noopener noreferrer">Teuteuf</a>. If
          you would like to avoid ads, consider upgrading to a premium experience.
        </p>
        <p class="footnote">
          * You will see ads unless you have ad blocker, in which case we would humbly ask that you
          either allow ads for GeoGrid (and other
          <a href="https://teuteuf.fr/" target="_blank" rel="noopener noreferrer">Teuteuf Games</a>)
          or upgrade to an ad-free premium.
        </p>
      </div>

      <div class="faq-item" id="what-makes-geogrid-different">
        <h3>
          <a href="#what-makes-geogrid-different" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          What makes GeoGrid different?
        </h3>
        <p>GeoGrid stands out from other geography games in three key ways:</p>
        <p>
          <strong>🎯 Dual-Criteria Challenge:</strong> Each square must satisfy two conditions (row
          + column), making every answer more complex than typical geography trivia.
        </p>
        <p>
          <strong>♟️ Strategic Gameplay:</strong> Countries can only be used once per board, so you
          must think several moves ahead—a bit like chess meets geography.
        </p>
        <p>
          <strong>🏆 Rarity-Based Scoring:</strong> Unlike games with single "correct" answers,
          GeoGrid rewards original thinking. The rarer your answer, the better your score. Success
          comes from finding countries other players haven't thought of.
        </p>
        <p>
          This unique combination attracts serious geography enthusiasts who enjoy both breadth of
          knowledge (flags, populations, GDP, Olympic medals) and strategic depth.
        </p>
      </div>

      <div class="faq-item" id="who-makes-geogrid">
        <h3>
          <a href="#who-makes-geogrid" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          Who makes GeoGrid?
        </h3>
        <p>
          In 2024, GeoGrid joined the suite of educational, geography-focused games supported by the
          geography-obsessed team at
          <a href="https://teuteuf.fr/" target="_blank" rel="noopener noreferrer">Teuteuf Games</a>.
          Since then, we've added a number of features to make the game more stable (back end
          improvements), easy to understand (clickable header categories with explanations), and fun
          (Achievements).
        </p>
        <p>
          Other popular games in our library include
          <a href="https://worldle.teuteuf.fr/" target="_blank" rel="noopener noreferrer">Worldle</a
          >,
          <a href="https://whentaken.com/" target="_blank" rel="noopener noreferrer">WhenTaken</a>,
          and <a href="https://travle.earth/" target="_blank" rel="noopener noreferrer">Travle</a>.
        </p>
      </div>

      <div class="faq-item" id="mobile-phone">
        <h3>
          <a href="#mobile-phone" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          Can I play GeoGrid on my mobile phone?
        </h3>
        <p>
          Yes! Roughly half our players are mobile users. We do our best to optimize the game for
          all formats.
        </p>
      </div>

      <div class="faq-item" id="how-long-to-complete">
        <h3>
          <a href="#how-long-to-complete" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          How long does it take to complete a GeoGrid game?
        </h3>
        <p>
          As a daily game, GeoGrid is meant to be quick and easy. At the same time, the harder you
          think about your answers, the likelier you are to do well. In this sense, the game is
          flexible. It can take a few minutes if you're in a hurry, or you can stretch it out,
          revisiting it during your breaks throughout the day.
        </p>
      </div>

      <div class="faq-item" id="streak-not-working">
        <h3>
          <a href="#streak-not-working" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          Why is my streak not working?
        </h3>
        <p>
          Streaks only work for games played in Daily Mode. While playing games in Archive mode
          after the fact is fun and will still earn you other types of Achievements, we feel it's
          best to award streaks to those players who show consistency by playing the current day's
          game each day.
        </p>
      </div>

      <div class="faq-item" id="game-summary-location">
        <h3>
          <a href="#game-summary-location" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          Where did the Game Summary go?
        </h3>
        <p>
          The game summary is now located on a separate tab in the upper left of the Summary page.
          After the game ends, click the right-most tab in the top bar of your game-end
          summary/pop-up.
        </p>
      </div>

      <div class="faq-item" id="statistics-window-change">
        <h3>
          <a href="#statistics-window-change" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          Why and when did the end-of-game statistics window change?
        </h3>
        <p>
          In June of 2025, we released a new game-end summary with substantial improvements. The
          updated summary adds new features the old one didn't have, such as: achievements, a score
          distribution graph, and KPI metrics.
        </p>
      </div>

      <div class="faq-item" id="fewer-players-worse-ranking">
        <h3>
          <a href="#fewer-players-worse-ranking" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          There seem to be fewer players AND my ranking is worse! What happened?
        </h3>
        <p>There are two reasons for this. In our previous system:</p>
        <ol>
          <li>
            We showed players who had in-progress games <em>as part of the total</em>. This inflated
            both the total number of players, and the number who had high (i.e. worse) scores.
          </li>
          <li>
            We grouped infinite and normal mode players together. However, infinite mode players
            tend to achieve much lower (i.e. better) scores. Thus, rather than compare apples to
            oranges, we broke the scores up into two groups.
          </li>
        </ol>
        <p>
          These changes were necessary to implement as part of our scoring system overhaul in June
          of 2025.
        </p>
      </div>

      <div class="faq-item" id="infinite-mode-counted">
        <h3>
          <a href="#infinite-mode-counted" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          When is my game counted as part of infinite mode?
        </h3>
        <p>
          Players can switch into infinite mode at any time before the game ends. However, once a
          player 1. switches into infinite mode AND 2. registers a guess,
          <em>the game will be counted in infinite mode</em>. At this point, the player can no
          longer switch back to normal mode.
        </p>
      </div>

      <div class="faq-item" id="achievement-stars">
        <h3>
          <a href="#achievement-stars" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          What do the stars ⭐️ next to Achievements mean?
        </h3>
        <p>The stars generally correspond with the percentage of players you beat:</p>
        <ul>
          <li>50-59%: ⭐️</li>
          <li>60-69%: ⭐️⭐️</li>
          <li>70-79%: ⭐️⭐️⭐️</li>
          <li>80-89%: ⭐️⭐️⭐️⭐️</li>
          <li>90-100%: ⭐️⭐️⭐️⭐️⭐️</li>
        </ul>
        <p>Certain achievements act a little different:</p>
        <p>
          For <strong>streak-based achievements</strong>, the longer you extend your streak, the
          more stars you get.
        </p>
        <p>For <strong>Legendary Hunter</strong>, the stars work as follows:</p>
        <ul>
          <li>2 legendaries = ⭐️</li>
          <li>3 legendaries = ⭐️⭐️</li>
          <li>4 legendaries = ⭐️⭐️⭐️</li>
          <li>5 legendaries = ⭐️⭐️⭐️⭐️</li>
          <li>6+ legendaries = ⭐️⭐️⭐️⭐️⭐️</li>
        </ul>
      </div>

      <div class="faq-item" id="achievements-score-distribution">
        <h3>
          <a href="#achievements-score-distribution" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          Can I see Achievements and the Score Distribution Graph for my previously played games?
        </h3>
        <p>
          Yes, you can. If you visit the Archive, you can play any game that you haven't already
          played and earn Achievements (though, please note that streak-based achievements aren't
          available in Archive mode.)
        </p>
        <p>
          When you re-visit an <em>already-played game</em>, our system will use your game's data to
          calculate Achievements and the Score Distribution graph. Thus, even games played before we
          released the new game-end summary system in June of 2025 will have this data available.
        </p>
      </div>

      <div class="faq-item" id="rank-change-previous-game">
        <h3>
          <a href="#rank-change-previous-game" class="faq-link">
            <svg class="link-icon" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.65 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              />
            </svg>
          </a>
          Why did my rank change on a previously-played game?
        </h3>
        <p>This can happen under 2 conditions:</p>
        <ol>
          <li>You revisit a game that was already played AND</li>
          <li>That game was played prior to our release of the Achievements system (June 2025)</li>
        </ol>
        <p>
          When this happens, we use your game data to calculate your Achievements, Rank, and Score
          Distribution Graph with our new system. This will result in an adjustment to your Rank for
          two reasons:
        </p>
        <ol>
          <li>
            Our system calculates rank differently now (see question about fewer players/worse
            ranking above)
          </li>
          <li>More players will have played the game since your last played it</li>
        </ol>
      </div>
    </div>

    <router-link to="/" class="btn-primary play-game-link-link">
      🎮 Play today's game!
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'FaqPage',
    mounted() {
      // Add JSON-LD structured data for FAQ
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'What is GeoGrid?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "GeoGrid is a daily geography trivia game made to put your geography knowledge to the test! Combining the concept of grid-games with geography, we believe it's one of the best daily geography games on the planet.",
            },
          },
          {
            '@type': 'Question',
            name: 'How does GeoGrid work?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "You must guess a country for each square in the board that matches the criteria specified by the square's row and column headers. When you get a correct answer, your score is calculated based on the percentage of people who also chose this answer. The rarer your answer, the lower your score. And lower score = better.",
            },
          },
          {
            '@type': 'Question',
            name: 'How many answers are there for a given square?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Each square on a given board has a minimum of 5 and up to 30 unique answers.',
            },
          },
          {
            '@type': 'Question',
            name: 'When is a new game available?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'GeoGrid is a daily game. A new game is released every day at 0:00 am (midnight), local time of your device!',
            },
          },
          {
            '@type': 'Question',
            name: 'Is GeoGrid free to play?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes, GeoGrid is completely free to play! You will see ads, which is how we support continued development of our educational, geography-based games at Teuteuf. If you would like to avoid ads, consider upgrading to a premium experience.',
            },
          },
          {
            '@type': 'Question',
            name: 'What makes GeoGrid different?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'GeoGrid stands out from other geography games in three key ways: Dual-Criteria Challenge (each square must satisfy two conditions), Strategic Gameplay (countries can only be used once per board), and Rarity-Based Scoring (rewards original thinking with rarer answers getting better scores).',
            },
          },
          {
            '@type': 'Question',
            name: 'Who makes GeoGrid?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'In 2024, GeoGrid joined the suite of educational, geography-focused games supported by the geography-obsessed team at Teuteuf Games. Other popular games in our library include Worldle, WhenTaken, and Travle.',
            },
          },
          {
            '@type': 'Question',
            name: 'Can I play GeoGrid on my mobile phone?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes! Roughly half our players are mobile users. We do our best to optimize the game for all formats.',
            },
          },
          {
            '@type': 'Question',
            name: 'How long does it take to complete a GeoGrid game?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "As a daily game, GeoGrid is meant to be quick and easy. It can take a few minutes if you're in a hurry, or you can stretch it out, revisiting it during your breaks throughout the day.",
            },
          },
          {
            '@type': 'Question',
            name: 'Why is my streak not working?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "Streaks only work for games played in Daily Mode. While playing games in Archive mode after the fact is fun and will still earn you other types of Achievements, we feel it's best to award streaks to those players who show consistency by playing the current day's game each day.",
            },
          },
          {
            '@type': 'Question',
            name: 'Where did the Game Summary go?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'The game summary is now located on a separate tab in the upper left of the Summary page. After the game ends, click the right-most tab in the top bar of your game-end summary/pop-up.',
            },
          },
          {
            '@type': 'Question',
            name: 'Why and when did the end-of-game statistics window change?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "In June of 2025, we released a new game-end summary with substantial improvements. The updated summary adds new features the old one didn't have, such as: achievements, a score distribution graph, and KPI metrics.",
            },
          },
          {
            '@type': 'Question',
            name: 'There seem to be fewer players AND my ranking is worse! What happened?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'There are two reasons for this. We previously showed players who had in-progress games as part of the total, which inflated numbers. We also grouped infinite and normal mode players together, but infinite mode players tend to achieve much better scores. We broke the scores up into two groups for fairer comparison.',
            },
          },
          {
            '@type': 'Question',
            name: 'When is my game counted as part of infinite mode?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Players can switch into infinite mode at any time before the game ends. However, once a player switches into infinite mode AND registers a guess, the game will be counted in infinite mode. At this point, the player can no longer switch back to normal mode.',
            },
          },
          {
            '@type': 'Question',
            name: 'What do the stars ⭐️ next to Achievements mean?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'The stars generally correspond with the percentage of players you beat: 50-59% gets 1 star, 60-69% gets 2 stars, 70-79% gets 3 stars, 80-89% gets 4 stars, and 90-100% gets 5 stars. Some achievements like streak-based ones and Legendary Hunter work differently.',
            },
          },
          {
            '@type': 'Question',
            name: 'Can I see Achievements and the Score Distribution Graph for my previously played games?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "Yes, you can. If you visit the Archive, you can play any game that you haven't already played and earn Achievements. When you re-visit an already-played game, our system will use your game's data to calculate Achievements and the Score Distribution graph.",
            },
          },
          {
            '@type': 'Question',
            name: 'Why did my rank change on a previously-played game?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'This can happen when you revisit a game that was played prior to our release of the Achievements system (June 2025). We use your game data to calculate your Achievements, Rank, and Score Distribution Graph with our new system, which calculates rank differently and includes more players who have played since your last visit.',
            },
          },
        ],
      });
      document.head.appendChild(script);
    },
    beforeUnmount() {
      // Clean up JSON-LD script when component is destroyed
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach((script) => {
        if (script.textContent && script.textContent.includes('FAQPage')) {
          script.remove();
        }
      });
    },
  };
</script>

<style scoped>
  .faq-container {
    padding: 20px;
    margin: 0 auto;
  }

  .page-title {
    margin-bottom: 40px;
    color: rgb(223, 223, 223);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-size: 2rem;
    font-weight: 600;
  }

  .geogrid-logo {
    height: 30px;
  }

  .faq-content {
    padding: 30px;
    color: rgb(223, 223, 223);
    text-align: left;
  }

  h2 {
    color: #fff;
    margin-bottom: 30px;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .faq-item {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(223, 223, 223, 0.2);
  }

  .faq-item:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }

  p {
    color: rgb(223, 223, 223);
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 10px;
  }

  .footnote {
    font-size: 14px;
    font-style: italic;
    color: rgba(223, 223, 223, 0.8);
  }

  a {
    color: #7ca3d3;
    text-decoration: none;
  }

  a:hover {
    color: #9bb8e0;
    text-decoration: underline;
  }

  ul,
  ol {
    color: rgb(223, 223, 223);
    margin-left: 20px;
    margin-bottom: 10px;
  }

  li {
    margin-bottom: 5px;
    line-height: 1.6;
  }

  strong {
    color: #fff;
  }

  em {
    font-style: italic;
  }

  h3 {
    position: relative;
  }

  /* FAQ Link Styles */
  .faq-link {
    position: absolute;
    left: -24px;
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
    color: rgba(223, 223, 223, 0.6);
    text-decoration: none;
    transition: color 0.2s ease;
  }

  .faq-link:hover {
    color: #7ca3d3;
  }

  .link-icon {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }

  h3 {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 1.2rem;
    font-weight: 600;
  }

  /* Smooth scrolling for hash links */
  html {
    scroll-behavior: smooth;
  }

  .play-game-link-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: inherit;
  }

  .play-game-link-link:visited {
    color: inherit;
  }

  .play-game-link-link:hover {
    text-decoration: none;
    background-color: rgba(184, 184, 249, 1);
  }

  /* Play Game Link Styles */
  .btn-primary {
    height: 44px;
    width: 50%;
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    background-color: rgba(147, 147, 236, 1);
    color: rgba(26, 26, 26, 1);
    border: 1px rgba(147, 147, 236, 1);
    padding: 6px 12px;
    border-radius: 12px;
    transition: background-color 0.3s;
    font-size: 14px;
    font-family: 'Oxygen', Helvetica, Arial, sans-serif;
    font-weight: 700;
    box-sizing: border-box;
  }

  @media screen and (max-width: 992px) {
    .faq-container {
      padding: 20px;
    }

    .page-title {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }

  @media screen and (max-width: 768px) {
    .faq-content {
      padding: 20px;
    }

    .page-title {
      font-size: 1.5rem;
    }

    .geogrid-logo {
      height: 22px;
    }
  }
</style>
